import React from "react";
import "./App.css";
import productImage from "./WhatsApp Image 2025-12-22 at 11.27.57 PM (1) (1).png";

function Contentonee() {
  return (
    <>
      <head>
        <title>OM Agro Foods | Mango Pulp Manufacturer & Exporter | Gir</title>

        <meta
          name="description"
          content="OM AGRO FOODS offers premium quality Kesar Mango Pulp made from handpicked mangoes. Ideal for aamras, ice creams, desserts, beverages, and bulk supply."
        />

        <meta
          name="keywords"
          content="Kesar Mango Pulp, om agro food rampara contact number, agro food, agro foods, kesar mango gir, om agro food gir contact number, Mango Pulp Manufacturer, Mango Pulp Supplier, OM AGRO FOODS, om agro foods, natural mango pulp, mango pulp, Aamras Pulp, Bulk Mango Pulp"
        />

        <link rel="canonical" href="https://omagrofoods.vercel.app/" />

        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="48x48" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="96x96" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="192x192" />
        <link rel="shortcut icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <link rel="apple-touch-icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <meta property="og:title" content="OM AGRO FOODS | Premium Kesar Mango Pulp" />
        <meta
          property="og:description"
          content="Premium quality Kesar Mango Pulp with rich taste, aroma, and natural sweetness. Available for retail and bulk orders."
        />
        <meta property="og:image" content={productImage} />
        <meta property="og:url" content="https://omagrofoods.vercel.app/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="OM AGRO FOODS | Premium Mango Pulp" />
        <meta
          name="twitter:description"
          content="Premium Kesar Mango Pulp supplier for homes, hotels, and food industries."
        />
        <meta name="twitter:image" content={productImage} />
      </head>

      <div className="contentone-container">

        <div className="contentone-header">
          <h1>Welcome to OM AGRO FOOD</h1>
          <p>Premium Quality Mango Products</p>
        </div>

        <div className="buy-pulp-top">
          <a href="/mango-pulp" className="buy-pulp-btn">
            🥭 Buy Mango Pulp
          </a>
        </div>

        <div className="contentone-product">
          <div className="contentone-image">
            <img src={productImage} alt="Om Kesar Mango Pulp" />
          </div>

          <div className="contentone-details">
            <h2>Om Kesar Mango Pulp</h2>

            <p className="description">
              Om Kesar Mango Pulp is produced using carefully selected premium
              Kesar mangoes. It delivers rich aroma, vibrant color, and natural
              sweetness, making it ideal for both home and commercial use.
            </p>

            <div className="features">
              <h3>Key Features</h3>
              <ul>
                <li>Made from premium Kesar mangoes</li>
                <li>Natural color and authentic taste</li>
                <li>Thick, smooth, and consistent texture</li>
                <li>Hygienically processed</li>
                <li>Long shelf life</li>
              </ul>
            </div>

            <div className="usage">
              <h3>Uses</h3>
              <p>
                Perfect for mango shakes, aamras, ice creams, kulfi,
                desserts, bakery products, lassi, mocktails, and beverages.
              </p>
            </div>

            <div className="packaging">
              <h3>Packaging</h3>
              <p>
                Available in small retail packs and large bulk packs.
                Food-grade, airtight, leak-proof, and easy-to-pour bottles.
              </p>
            </div>

            <div className="storage">
              <h3>Storage Instructions</h3>
              <p>
                Store in a cool and dry place. Refrigerate after opening and
                consume within the recommended period.
              </p>
            </div>
          </div>
        </div>

        <div className="mango-types-section">
          <h2>Types of Mangoes We Use</h2>

          <div className="mango-grid">
            <div className="mango-card">
              <h3>Kesar Mango</h3>
              <p>
                Origin: Gujarat | Taste: Very sweet & aromatic |
                Texture: Smooth & fiberless.
              </p>
            </div>

            <div className="mango-card">
              <h3>Hapus</h3>
              <p>
                Origin: Maharashtra | Taste: Rich & creamy |
                Texture: Fiberless.
              </p>
            </div>

            <div className="mango-card">
              <h3>Totapuri</h3>
              <p>
                Origin: South India | Taste: Mild sweet & tangy |
                Texture: Slightly fibrous.
              </p>
            </div>

            <div className="mango-card">
              <h3>Langra</h3>
              <p>
                Origin: Uttar Pradesh | Taste: Sweet with mild tang |
                Texture: Fiberless.
              </p>
            </div>
          </div>
        </div>

        <div className="contentone-container-whychoose-maindiv">
          <h2>Why Choose OM AGRO FOOD?</h2>
          <ul className="contentone-container-whychoose">
            <li>Wide range of premium mango varieties</li>
            <li>Consistent taste and quality</li>
            <li>Strict hygiene and safety standards</li>
            <li>Trusted by food & beverage industries</li>
            <li>Bulk and retail packaging options</li>
          </ul>
        </div>

      </div>
    </>
  );
}

export default Contentonee;
